// @ts-nocheck -- copied verbatim from the application being replaced.
//
// Quarantined, not exempted. This file has not been rewritten to this project's
// settings and does not pass them; checking it would report errors nobody is
// going to fix in place, and loosening the settings to accommodate it would
// apply that to code written here too. Vite still compiles it -- esbuild strips
// types without checking them.
//
// Delete this line when the file is rewritten. It is the marker for what is left
// to do, and the count of files carrying it is the size of the refactor.
/**
 * Google Analytics 4 (GA4) event helper utilities.
 *
 * Usage:
 *   import { trackLogin, trackSignUp, trackEvent } from '../utils/analytics';
 *   trackLogin('google');
 *
 * All functions are safe to call even if the GA script hasn't loaded yet —
 * they check for the presence of `gtag` before calling it.
 */

import ENV from '../config/legacy-env.js';

const safe = (fn: () => void) => {
  if (typeof gtag === 'function' && ENV.ANALYTICS_ENABLED) fn();
};

// ---------------------------------------------------------------------------
// Auth events
// ---------------------------------------------------------------------------

/** Fire when a user successfully logs in. */
export const trackLogin = (method: 'email' | 'google' | 'github' | 'linkedin' | 'magic_link') => {
  safe(() => gtag('event', 'login', { method }));
};

/** Fire when a user successfully completes registration. */
export const trackSignUp = (method: 'email' | 'google' | 'github' | 'linkedin') => {
  safe(() => gtag('event', 'sign_up', { method }));
};

// ---------------------------------------------------------------------------
// Engagement events
// ---------------------------------------------------------------------------

/** Fire when a user submits the contact/support form. */
export const trackContactSubmit = () => {
  safe(() => gtag('event', 'contact_form_submit', { event_category: 'engagement' }));
};

/** Fire when a user subscribes via the subscribe modal. */
export const trackSubscribe = () => {
  safe(() => gtag('event', 'subscribe', { event_category: 'engagement' }));
};

/** Fire when a user views a brand page. */
export const trackBrandView = (brandName: string) => {
  safe(() => gtag('event', 'view_item', { event_category: 'brand', item_name: brandName }));
};

/** Fire when a user performs a brand/site search. */
export const trackSearch = (searchTerm: string) => {
  safe(() => gtag('event', 'search', { search_term: searchTerm }));
};

/** Fire when a user clicks "Book a Demo". */
export const trackBookDemo = () => {
  safe(() => gtag('event', 'book_demo', { event_category: 'conversion' }));
};

/** Fire when a user clicks a pricing CTA. */
export const trackPricingClick = (planName: string) => {
  safe(() => gtag('event', 'pricing_click', { event_category: 'conversion', plan_name: planName }));
};

// ---------------------------------------------------------------------------
// Generic escape hatch
// ---------------------------------------------------------------------------

/** Fire any arbitrary GA4 event. */
export const trackEvent = (eventName: string, params?: Record<string, unknown>) => {
  safe(() => gtag('event', eventName, params));
};
